import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { motion } from "framer-motion";
import servicesImg from "../../static/media/services/services.webp";

const StrategicServices = () => {
  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        py: isMobile ? 4 : 6,
      }}
    >
      <Box
        sx={{
          width: isMobile ? "90%" : "75%",
          height: isMobile ? "auto" : "580px",
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundImage: `url(${servicesImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          borderRadius: 16,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 1,
          }}
        />

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          style={{
            position: "relative",
            zIndex: 2,
            textAlign: "center",
            color: "#fff",
            padding: "2rem",
            maxWidth: "90%",
          }}
        >
          <Typography
            variant={isMobile ? "h4" : "h2"}
            sx={{
              fontWeight: "bold",
              mb: 3,
              textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
            }}
          >
            ALIANZAS ESTRATÉGICAS
          </Typography>

          {[
            "🔧 Mantenimiento preventivo y correctivo de sistemas mecánicos",
            "🌱 Sistemas de riego automatizados y sostenibles",
            "🏗️ Asesoramiento profesional en construcción",
          ].map((text, index) => (
            <Typography
              key={index}
              variant={isMobile ? "body1" : "h6"}
              sx={{
                mb: 2,
                textShadow: "1px 1px 3px rgba(0,0,0,0.5)",
              }}
            >
              {text}
            </Typography>
          ))}
        </motion.div>
      </Box>
    </Box>
  );
};

export default StrategicServices;
